export const VISUAL_VIEW_TYPE = "visual-view";
export function isVisualView(what) {
    return what.type.includes(VISUAL_VIEW_TYPE);
}
//# sourceMappingURL=visual-view.js.map